import _ from 'lodash';

import {
  // EditProductionRecordFieldEnum as EditProdRecordFields,
  ProductionRecordFieldEnum as ProdRecordFields,
  ProductionRecordDetailFieldEnum as ProdRecordDetailFields,
  ProductionRecipeLeftoverEnum as ProdRecipeLeftoverFields,
  ProductionRecipeLeftoverDetailEnum as ProdLeftoverDetailFields,
} from 'Common/FieldEnum';

import * as ProdRecordHelpers from './productionRecord';
import * as FormSelectors from './formSelectors';
import { ActionTypes } from '../subpages/editproduction/components/EditProductionForm';

export const updatePlannedPercentages = (prodRecord, ff) => {
  const feedingFigure = Number(ff);

  const details = [...prodRecord[ProdRecordFields.Details]];

  details.forEach((d) => {
    if (feedingFigure) {
      d[ProdRecordDetailFields.PlannedPercentage] = Number(
        (Number(d[ProdRecordDetailFields.ReimbursableMeals]) / feedingFigure) *
          100
      ).toFixed(2);
    } else {
      d[ProdRecordDetailFields.PlannedPercentage] = '0.00';
    }
  });

  prodRecord[ProdRecordFields.Details] = details;

  return prodRecord;
};

/**
 * Updates the ingredient amounts for the details in a given production record.
 * @param {Object} prodRecord - production record
 * @param {Object} recipesById - recipe ids mapped to their recipe
 * @return {List} the updated details
 */
export const updateIngredientAmounts = (prodRecord, recipesById) => {
  const details = [..._.get(prodRecord, ProdRecordFields.Details, [])];

  const updatedDetails = details.map((detail) => {
    const recipeId = detail[ProdRecordDetailFields.RecipeId];
    const recipe = recipesById[recipeId];

    if (detail[ProdRecordDetailFields.IsSingleIngredientRecipe]) {
      detail[
        ProdRecordDetailFields.IngredientAmount
      ] = ProdRecordHelpers.getIngredientAmount(detail, recipe);
    } else {
      const ingredients = ProdRecordHelpers.getRecipeIngredients(
        prodRecord[ProdRecordFields.Details],
        detail[ProdRecordDetailFields.RecipeId]
      );

      if (ingredients.length > 0) {
        ingredients.forEach((i) => {
          i[
            ProdRecordDetailFields.IngredientAmount
          ] = ProdRecordHelpers.getIngredientAmount(i, recipe);
        });
      }
    }
    return detail;
  });

  return updatedDetails;
};

export const updateForm = (state, payload) => {
  const { index, value, name } = payload;
  const {
    prodRecords,
    detailsByRecipeCategory,
    viewProdRecordIndex,
    expandedRecipesByCategory,
  } = state;

  const newProdRecords = [...prodRecords];
  let newDetailsByRecipeCategory = {
    ...detailsByRecipeCategory,
  };
  let detail;
  let prodRecord = newProdRecords[viewProdRecordIndex];

  if (!_.isNil(index)) {
    detail = {
      ..._.get(prodRecord, [ProdRecordFields.Details, index]),
    };
  }

  const parsedValue = Number(value) || 0;

  switch (name) {
    case ProdRecordFields.FeedingFigureAlacarte:
    case ProdRecordFields.FeedingFigureAdult:
      prodRecord[name] = value;
      break;
    case ProdRecordFields.FeedingFigure:
      prodRecord[name] = value;
      prodRecord = updatePlannedPercentages(
        newProdRecords[viewProdRecordIndex],
        value
      );
      newProdRecords[viewProdRecordIndex] = prodRecord;
      break;
    case ProdRecordDetailFields.ReimbursableMeals: {
      let plannedPercentage;
      const feedingFigure = FormSelectors.getFeedingFigure(state);

      if (feedingFigure && detail) {
        plannedPercentage = (parsedValue / feedingFigure) * 100;
        detail[ProdRecordDetailFields.PlannedPercentage] = Number(
          plannedPercentage
        ).toFixed(2);
      } else {
        plannedPercentage = '0.00';
      }

      detail[ProdRecordDetailFields.ReimbursableMeals] = parsedValue;
      detail[ProdRecordDetailFields.Offered] = parsedValue;
      detail[
        ProdRecordDetailFields.Served
      ] = ProdRecordHelpers.computeOfferedTotal(detail);
      break;
    }
    case ProdRecordDetailFields.PlannedPercentage: {
      const feedingFigure = FormSelectors.getFeedingFigure(state);

      const percentage = Number(parsedValue);
      const plannedReimb = percentage
        ? Math.round((feedingFigure * percentage) / 100)
        : 0;
      detail[ProdRecordDetailFields.PlannedPercentage] = value;
      detail[ProdRecordDetailFields.ReimbursableMeals] = plannedReimb;
      detail[ProdRecordDetailFields.Offered] = plannedReimb;
      detail[
        ProdRecordDetailFields.Served
      ] = ProdRecordHelpers.computeOfferedTotal(detail);
      break;
    }
    case ProdRecordDetailFields.PlannedAlacarte: {
      detail[ProdRecordDetailFields.PlannedAlacarte] = parsedValue;
      detail[ProdRecordDetailFields.OfferedAlacarte] = parsedValue;
      detail[ProdRecordDetailFields.ServedAlacarte] = parsedValue;
      detail[
        ProdRecordDetailFields.Served
      ] = ProdRecordHelpers.computeOfferedTotal(detail);
      break;
    }
    case ProdRecordDetailFields.PlannedAdult: {
      detail[ProdRecordDetailFields.PlannedAdult] = parsedValue;
      detail[ProdRecordDetailFields.OfferedAdult] = parsedValue;
      detail[ProdRecordDetailFields.ServedAdult] = parsedValue;
      detail[
        ProdRecordDetailFields.Served
      ] = ProdRecordHelpers.computeOfferedTotal(detail);
      break;
    }
    case ProdRecordDetailFields.PlannedPreK: {
      detail[ProdRecordDetailFields.PlannedPreK] = parsedValue;
      detail[ProdRecordDetailFields.OfferedPreK] = parsedValue;
      detail[ProdRecordDetailFields.ServedPreK] = parsedValue;
      detail[
        ProdRecordDetailFields.Served
      ] = ProdRecordHelpers.computeOfferedTotal(detail);
      break;
    }
    case ProdRecordDetailFields.Offered: {
      detail[ProdRecordDetailFields.Offered] = parsedValue;
      detail[
        ProdRecordDetailFields.Served
      ] = ProdRecordHelpers.computeOfferedTotal(detail);
      break;
    }
    case ProdRecordDetailFields.OfferedAlacarte: {
      detail[ProdRecordDetailFields.OfferedAlacarte] = parsedValue;
      detail[ProdRecordDetailFields.ServedAlacarte] = parsedValue;
      detail[
        ProdRecordDetailFields.Served
      ] = ProdRecordHelpers.computeOfferedTotal(detail);
      break;
    }
    case ProdRecordDetailFields.OfferedAdult: {
      detail[ProdRecordDetailFields.OfferedAdult] = parsedValue;
      detail[ProdRecordDetailFields.ServedAdult] = parsedValue;
      detail[
        ProdRecordDetailFields.Served
      ] = ProdRecordHelpers.computeOfferedTotal(detail);
      break;
    }
    case ProdRecordDetailFields.OfferedPreK: {
      detail[ProdRecordDetailFields.OfferedPreK] = parsedValue;
      detail[ProdRecordDetailFields.ServedPreK] = parsedValue;
      detail[
        ProdRecordDetailFields.Served
      ] = ProdRecordHelpers.computeOfferedTotal(detail);
      break;
    }
    case ProdRecordDetailFields.ServingLine:
      detail[ProdRecordDetailFields.ServingLine] = value;
      break;
    default: {
      detail[name] = value;
      break;
    }
  }

  // Update item in category list so that its reflected on the grid
  if (!_.isNil(index) && detail) {
    prodRecord[ProdRecordFields.Details][index] = detail;
    const categoryItems =
      newDetailsByRecipeCategory[
        detail[ProdRecordDetailFields.RecipeCategoryId]
      ];
    const categoryItemIndex = categoryItems.findIndex(
      (item) =>
        item[ProdRecordDetailFields.ReactKey] ===
        detail[ProdRecordDetailFields.ReactKey]
    );

    if (categoryItemIndex !== -1) {
      categoryItems[categoryItemIndex] = detail;
    }
  }

  // Check to see if ingredient amount needs to be updated
  if (
    name === ProdRecordDetailFields.QtyOfPortion ||
    name === ProdRecordDetailFields.ReimbursableMeals ||
    name === ProdRecordDetailFields.PlannedAdult ||
    name === ProdRecordDetailFields.PlannedAlacarte ||
    name === ProdRecordDetailFields.PlannedPreK ||
    name === ProdRecordDetailFields.PlannedPercentage
  ) {
    const recipesById = FormSelectors.getProdRecordRecipesById(state);
    newProdRecords[viewProdRecordIndex][
      ProdRecordDetailFields.Details
    ] = updateIngredientAmounts(prodRecord, recipesById);
    newDetailsByRecipeCategory = ProdRecordHelpers.groupDetailsByRecipeCategory(
      prodRecord[ProdRecordFields.Details],
      expandedRecipesByCategory
    );
  }

  return {
    prodRecords: newProdRecords,
    detailsByRecipeCategory: newDetailsByRecipeCategory,
  };
};

export const deleteDetail = (state, payload) => {
  const { index } = payload;
  const { viewProdRecordIndex, prodRecords, expandedRecipesByCategory } = state;

  const newProdRecords = [...prodRecords];
  const prodRecord = { ...newProdRecords[viewProdRecordIndex] };
  let details = prodRecord[ProdRecordFields.Details];

  if (!_.isNil(index)) {
    const detail = details[index];
    const isLeftover = ProdRecordHelpers.isLeftover(detail);

    // Remove the recipe and the ingredients associated with the detail
    const recipeId = detail[ProdRecordDetailFields.RecipeId];
    details = details.filter(
      (pd) =>
        pd[ProdRecordDetailFields.RecipeId] !== recipeId ||
        // Avoid removing all instances of the recipe by checking against whether it is a leftover or not
        (pd[ProdRecordDetailFields.RecipeId] === recipeId &&
          pd[ProdRecordDetailFields.IsLeftover] !== isLeftover)
    );

    details.forEach((d, i) => (d[ProdRecordDetailFields.ArrayIndex] = i));
    newProdRecords[viewProdRecordIndex][ProdRecordFields.Details] = details;
    const newDetailsByRecipeCategory = ProdRecordHelpers.groupDetailsByRecipeCategory(
      details,
      expandedRecipesByCategory
    );

    return {
      prodRecords: newProdRecords,
      detailsByRecipeCategory: newDetailsByRecipeCategory,
    };
  }

  return {};
};

export const addRecipe = (state, payload) => {
  const { viewProdRecordIndex, prodRecords, expandedRecipesByCategory } = state;
  const { recipe, isLeftover } = payload;
  const newProdRecords = [...prodRecords];
  let newDetails = [
    ...newProdRecords[viewProdRecordIndex][ProdRecordFields.Details],
  ];
  const details = FormSelectors.getProdDetails(state);

  const index = newDetails.findIndex(
    (d) =>
      ProdRecordHelpers.isLeftover(d) &&
      d[ProdRecordDetailFields.RecipeId] === recipe[ProdRecipeLeftoverFields.Id]
  );

  // Leftover recipe already exists on the production record so just add to it
  if (isLeftover && index > -1) {
    const detail = { ...newDetails[index] };
    const leftoverDetails = detail[ProdRecordDetailFields.Leftovers];
    const leftovers = recipe[ProdRecipeLeftoverFields.Leftovers];
    let totalAdded = 0;

    leftovers.forEach((l) => {
      const leftoverDetail = leftoverDetails.find(
        (ld) =>
          ld[ProdLeftoverDetailFields.RecipeLeftoverId] ===
          l[ProdRecipeLeftoverFields.RecipeLeftoverId]
      );

      if (leftoverDetail) {
        const portions = l[ProdRecipeLeftoverFields.Portions];
        leftoverDetail[ProdLeftoverDetailFields.Portions] += portions;

        totalAdded += portions;
      } else {
        leftoverDetails.push(l);
      }
    });
    detail[ProdRecordDetailFields.Offered] =
      (Number(detail[ProdRecordDetailFields.Offered]) || 0) + totalAdded;

    detail[
      ProdRecordDetailFields.Served
    ] = ProdRecordHelpers.computeOfferedTotal(detail);

    newDetails[index] = detail;
  } else {
    // Adding new recipe / new leftover recipe
    newDetails = [
      ...details,
      ...ProdRecordHelpers.convertRecipeForProdRecord({
        recipe,
        isLeftover,
      }),
    ];
    newDetails.forEach((d, i) => (d[ProdRecordDetailFields.ArrayIndex] = i));
  }
  newProdRecords[viewProdRecordIndex][ProdRecordFields.Details] = newDetails;

  return {
    prodRecords: newProdRecords,
    detailsByRecipeCategory: ProdRecordHelpers.groupDetailsByRecipeCategory(
      newDetails,
      expandedRecipesByCategory
    ),
  };
};

export const updateGrid = (state, payload) => {
  const {
    prodRecords,
    viewProdRecordIndex,
    expandedRecipesByCategory,
  } = payload;
  const detailsByRecipeCategory = ProdRecordHelpers.groupDetailsByRecipeCategory(
    prodRecords[viewProdRecordIndex][ProdRecordFields.Details],
    expandedRecipesByCategory
  );

  return {
    prodRecords,
    detailsByRecipeCategory,
    expandedRecipesByCategory,
    viewProdRecordIndex,
  };
};

export const getInputChangePayload = (e) => {
  const index =
    _.get(e, 'target.parentNode.dataset.index', '') || e.target.index;

  return {
    type: ActionTypes.Change,
    payload: {
      name: e.target.name,
      value: e.target.value,
      index,
    },
  };
};

export const getUpdatedProdRecordFromProdPlanChanges = (state, formValues) => {
  const prodRecord = { ...FormSelectors.getProdRecord(state), ...formValues };

  return prodRecord;
};

export const addProductionPlanChanges = (state, payload) => {
  const viewProdRecordIndex = FormSelectors.getViewProdRecordIndex(state);
  const { formValues } = payload;
  const prodRecords = [...FormSelectors.getProdRecords(state)];

  const updatedProdRecord = getUpdatedProdRecordFromProdPlanChanges(
    state,
    formValues
  );

  prodRecords[viewProdRecordIndex] = updatedProdRecord;
  return { prodRecords };
};



// WEBPACK FOOTER //
// ./src/pages/manageproduction/helpers/form.js